import React from "react";
import * as PropTypes from "prop-types";
import {
  Box,
  Text,
  Button,
  Collapse,
} from "@chakra-ui/core";
import { CategoryHeading } from "../../headings";
import { getRangesSummary } from "./functions";
import ScheduleType from "../../venues/scheduleType";
import { useIntl } from "gatsby-plugin-intl";

const ScheduleCollapse = ({ schedule, isOpen, onClose, ...props }) => {
  const intl = useIntl();
  const cancelRef = React.useRef();
  if (schedule) {
    const data = getRangesSummary(schedule, intl.locale);
    return (
      <Collapse mt={4} isOpen={isOpen} {...props}>
        <Text>
          {intl.formatMessage({ id: "places.weeklySchedule" })}
        </Text>
        {data.map(item => (
          <Box key={item.name}>
            <CategoryHeading fontHeight="700" my={2}>{item.name}</CategoryHeading>
            <Box>
              {!!item.closed ? (
                <Text color="red.500">
                  {item.schedules[0]}
                </Text>
              ) : item.schedules.map(schedule => !!schedule && (
                <Text key={`${item.name}${schedule}`} color="green.500">
                  {schedule}
                </Text>
              ))}
            </Box>
          </Box>
        ))}
        <Button ref={cancelRef} onClick={onClose}>
          {intl.formatMessage({ id: "form.ok" })}
        </Button>
      </Collapse>
    );
  }
  return null;
};

ScheduleCollapse.propTypes = {
  schedule: ScheduleType,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

ScheduleCollapse.defaultProps = {
  schedule: null,
  isOpen: false,
  onClose: () => {},
};

export default ScheduleCollapse;
